module.exports = __webpack_public_path__ + "microCampaignGraphBg.svg?16bf0df7726ab58d724c66f449c8a60f";